module.exports = __webpack_public_path__ + "img/banner_LL_centralajuda.c81d2f2e.jpg";